import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import {
  OrderConfirmListSortField,
  orderConfirmUrl,
  OrderConfirmUrlQueryParams
} from "@saleor/OrderConfirm/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import OrderConfirmView from "./views/OrderConfirmView";

const OrderConfirmSection = () => {
  const intl = useIntl();

  const OrderConfirmViewSection: React.FC<RouteComponentProps<any>> = ({
    location
  }) => {
    const qs = parseQs(location.search.substr(1));
    const params: OrderConfirmUrlQueryParams = asSortParams(
      qs,
      OrderConfirmListSortField,
      OrderConfirmListSortField.soNo
    );
    return <OrderConfirmView params={params} />;
  };

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.orderConfirm)} />
      <Switch>
        <Route exact path={orderConfirmUrl} render={OrderConfirmViewSection} />
      </Switch>
    </>
  );
};

export default OrderConfirmSection;
